import React, { useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import PrivateRoute from "components/PrivateRoute";
import styled, { createGlobalStyle } from "styled-components";
import { AppContext } from "contexts/AppContext";
import AdminSidebar from "components/Sidebar/AdminSidebar.js";

const GlobalStyle = createGlobalStyle`
`;

const SidebarWrapper = styled.div`
  width: 250px;
  top: 0 !important;
  height: 100vh;
  max-height: 100vh;

  @media (max-width: 768px) {
    position: fixed;
    z-index: 1000;
  }
`;

export const AdminLayout = () => {
  const [sidebarWidth, setSidebarWidth] = useState(250);
  const { theme } = useContext(AppContext);

  /*useEffect(() => {
    const html = document.documentElement;
    html.setAttribute("data-aw-theme", theme);
  }, [theme]);*/

  return (
    <PrivateRoute>
      <GlobalStyle />
      <div data-aw-theme={theme} style={{ overflow: "hidden", display: "flex", flexDirection: "row", backgroundColor: "var(--page-bg)" }}>
        <SidebarWrapper style={{ width: `${sidebarWidth}px` }}>
          <AdminSidebar
            onClosed={(closed) => {
              console.log("!!! CLOSED", closed);
              if (closed) {
                setSidebarWidth(10);
              } else {
                setSidebarWidth(250);
              }
            }}
          />
        </SidebarWrapper>
        <div
          style={{
            marginTop: "20px",
            marginLeft: "40px",
            marginRight: "20px",
            width: `calc(100% - ${sidebarWidth + 60}px)`,
            position: "relative",
            zIndex: 1,
            borderRadius: "8px",
            /*height: "2000px",*/
          }}
        >
          <Outlet />
        </div>
      </div>
    </PrivateRoute>
  );
};

export default AdminLayout;
